<template>
  <div class="promo_discount__list">
    <div class="vx-card p-6">
      <vs-table
        id="table-loading"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="500px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        pagination
        :max-items="length"
        search
        :data="promoDiscounts"
      >
        <template slot="header">
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center">
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">
                    {{ page * length - (length - (FilteredCount && 1)) }}
                    -
                    {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                    of {{ FilteredCount }} (filtered from {{ total }} total entries)
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="handleChangeLength(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <!-- add register btn -->
            <div
              v-if="promoDiscountTable.addNewButton && checkPermissionByIds(promoDiscountTable.addNewButton.permission)"
              @click="toggleAddDiscountModal"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
            >
              <feather-icon v-if="promoDiscountTable.addNewButton.btnIcon" :icon="promoDiscountTable.addNewButton.btnIcon" svgClasses="h-4 w-4" />
              <span v-if="promoDiscountTable.addNewButton.btnTitle" class="ml-2 text-base text-primary">{{ promoDiscountTable.addNewButton.btnTitle }}</span>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th v-for="(column, index) in promoDiscountTable.tableColumns" :key="index" :sort-key="column.columnSortKey">{{ column.title }}</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td>
              {{ tr.discount_name }}
            </vs-td>
            <vs-td> {{ tr.discount_on }} - {{ tr.discount_type.toLowerCase() }} </vs-td>
            <vs-td>
              <vs-switch color="primary" :value="tr.discount_status" @input="updatePromoDiscountStatus(tr.id, !tr.discount_status)">
                <span slot="on">Active</span>
                <span slot="off">Inactive</span>
              </vs-switch>
            </vs-td>
            <vs-td>
              <div class="inline-flex">
                <!-- edit promo discount -->
                <vx-tooltip text="Edit Promo Discount" v-if="checkPermissionByIds([permissions.PROMO_DISCOUNT_EDIT])">
                  <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="toggleEditDiscountModal(tr.id)" />
                </vx-tooltip>

                <!-- delete promo discount -->
                <vx-tooltip text="Delete Promo Discount" v-if="checkPermissionByIds([permissions.PROMO_DISCOUNT_DELETE])">
                  <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="deletePromoDiscountConfirmation(tr.id)" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- add promo discount modal -->
    <AddPromoDiscountModal v-if="isAddPromoDiscountModalMounted" :isModalShow.sync="isAddPromoDiscountModalShow" @done="getPromoDiscountList" />

    <!-- edit promo discount modal -->
    <EditPromoDiscountModal v-if="isEditPromoDiscountModalMounted" :isModalShow.sync="isEditPromoDiscountModalShow" :selectedPromoDiscountId="selectedPromoDiscountId" @done="getPromoDiscountList" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import AddPromoDiscountModal from '@/views/promo-discount/components/AddPromoDiscountModal'
import EditPromoDiscountModal from '@/views/promo-discount/components/EditPromoDiscountModal'

export default {
  name: 'PromoDiscountList',

  components: {
    AddPromoDiscountModal,
    EditPromoDiscountModal
  },

  data() {
    return {
      page: 1,
      length: 10,
      search: null,
      order: [],
      promoDiscounts: [],

      // add promo discount modal
      isAddPromoDiscountModalMounted: false,
      isAddPromoDiscountModalShow: false,

      // edit promo discount modal
      isEditPromoDiscountModalMounted: false,
      isEditPromoDiscountModalShow: false,
      selectedPromoDiscountId: null
    }
  },

  mounted() {
    // get promo discount list
    this.getPromoDiscountList()
  },

  computed: {
    ...mapState('promo_discount', ['promoDiscountTable', 'total', 'FilteredCount']),
    ...mapState('permission', ['permissions']),
    ...mapGetters('auth', ['checkPermissionByIds'])
  },

  methods: {
    // get promo discount list
    getPromoDiscountList() {
      this.$store
        .dispatch('promo_discount/getPromoDiscountList', {
          page: this.page,
          limit: this.length,
          search: this.search,
          order: this.order
        })
        .then((res) => {
          this.promoDiscounts = res.data
        })
    },

    // delete promo discount - confirmation
    deletePromoDiscountConfirmation(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => this.deletePromoDiscount(id),
        acceptText: 'Delete'
      })
    },

    // delete register
    async deletePromoDiscount(id) {
      this.$store
        .dispatch('promo_discount/deletePromoDiscount', id)
        .then(({ message }) => {
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.promoDiscounts = []
          this.getPromoDiscountList()
        })
        .catch(({ message }) => {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // update promo status
    updatePromoDiscountStatus(id, status) {
      this.$store
        .dispatch('promo_discount/updatePromoDiscountStatus', { id, status })
        .then(({ message }) => {
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.promoDiscounts = []
          this.getPromoDiscountList()
        })
        .catch(({ message }) => {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // handle search promo discount
    updateSearchQuery() {},

    // handle page change promo discount
    handleChangePage() {},

    // handle sort promo discount
    handleSort() {},

    // toggle add discount modal
    toggleAddDiscountModal() {
      this.isAddPromoDiscountModalMounted = true
      this.isAddPromoDiscountModalShow = true
    },

    // toggle edit discount modal
    toggleEditDiscountModal(id) {
      this.selectedPromoDiscountId = id
      this.isEditPromoDiscountModalMounted = true
      this.isEditPromoDiscountModalShow = true
    }
  },

  watch: {
    // callback handle - add promo discount modal
    isAddPromoDiscountModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddPromoDiscountModalMounted = false
          }, 0)
        }
      }
    },

    // callback handle - edit promo discount modal
    isEditPromoDiscountModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isEditPromoDiscountModalMounted = false
            this.selectedPromoDiscountId = null
          }, 0)
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>